<template>
	<div v-if="loaded">
		<h4 class="primary--text">{{ $t('headercreator.title') }}</h4>
		<v-row v-for="(row, indexRow) in formHeaderLayout.rows" :key="`row-${id}-${indexRow}`" class="mt-0">
			<v-col row v-for="(column, indexColumn) in row.columns" :key="`column-${id}-${indexRow}-${indexColumn}`" :cols="12" :md="column.size">
				<header-component-generator
					:column="column"
					:indexColumn="indexColumn"
					@newValue="(val) => handleNewValue(val, indexRow, indexColumn)"
					:userData="getUserDataFromHash"
				></header-component-generator>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import HeaderComponentGenerator from './HeaderComponentGenerator.vue';
import { mapGetters } from 'vuex';
export default {
	name: 'headercreator',
	components: {
		'header-component-generator': HeaderComponentGenerator
	},
	props: {
		formHeaderLayout: {
			type: Object
		},
		id: {
			type: [String, Number],
			required: true
		}
	},
	data() {
		return {
			loaded: false,
			formHeaderValue: []
		};
	},
	methods: {
		handleNewValue(val, indexRow, indexColumn) {
			this.formHeaderValue[indexRow].columns[indexColumn].value = val;
			this.$emit('formHeaderUpdate', this.formHeaderValue);
		}
	},
	created() {
		// when we have login we need to update this data of the user
		// this.existingUserData = window.localStorage.getItem('existingUserData') ? JSON.parse(window.localStorage.getItem('existingUserData')) : null;
		this.formHeaderValue = JSON.parse(JSON.stringify(this.formHeaderLayout.rows));
		this.loaded = true;
	},
	watch: {
		formHeaderLayout: {
			handler() {
				this.formHeaderValue = JSON.parse(JSON.stringify(this.formHeaderLayout.rows));
			},
			deep: true
		}
	},
	computed: {
		...mapGetters(['getUserDataFromHash'])
	}
};
</script>

<style></style>
